//
//
//
//
//
//

import {
  UserMixin
} from "~/node_modules/sitis-nuxt/lib/mixins";
export default {
  head: function () {
    return {
      htmlAttrs: {
        ...this.getHeadHtmlAttrs
      },
    }
  },

  props: [
    "error"
  ],

  computed: {
    getHeadHtmlAttrs: function () {
      let headItems = {
        lang: this.$hreflangInitial(),
      };

      const lang = this?.$i18n?.locale || this?.$i18n?.defaultLocale || "en";
      if (lang === "ar") {
        headItems.dir = "rtl";
      }

      return headItems
    }
  },

  mixins: [
    UserMixin
  ],

  components: {
    ErrorContent: () => import("~/components/layouts/ErrorContent.vue")
  },

  mounted: async function () {
    await this.getUser();
    await this.$store.dispatch("services/getListServices", {
      isResetPagination: true,
      isLoadMore: false,
    });
  }
};
